import TrendingSingleCampaignCard from './trendingSingleCampaignCard.component';

export default TrendingSingleCampaignCard;